"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessibilityPadding = void 0;

var _constants = require("./constants");

var _utils = require("./utils");

var getAccessibilityPadding = function getAccessibilityPadding(lineHeight, fontSize) {
  var contentHeight = !fontSize || fontSize === '' ? _constants.EM_TO_PX_RATIO * _constants.DEFAULT_LINE_HEIGHT : (0, _utils.getContentHeight)(lineHeight, fontSize);
  return Math.ceil((_constants.A11Y_MIN_SIZE - contentHeight) / 2);
};

exports.getAccessibilityPadding = getAccessibilityPadding;